<template>
  <Container>
    <h1>Equilibre</h1>

    <table>
        <thead>
          <tr>
            <th>Joueur</th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchPlayed')">Matchs joués</a></th>
            <th><a href="#"  v-on:click="sortPlayersBy('matchAsReferee')">Matchs arbitrés</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="playerStats in stats" v-bind:key="playerStats.id">
            <td>{{playerStats.firstname}} {{playerStats.name}}</td>
            <td>{{playerStats.matchPlayed}}</td>
            <td>{{playerStats.matchAsReferee}}</td>
          </tr>
        </tbody>
      </table>
  </Container>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Container from '@/components/Container.vue';

export default {
  name: "balance",
  data: function(){
    return {
      stats : []
    }
  },
  components: {
    Container
  },
  computed: {
    mostEnduringPlayer() {
      return (this.stats.length > 0) ? this.stats.reduce((x, y) => (x.pointsPlayed - y.pointsPlayed > 0) ? x : y) : "";
    },
    mostLazyPlayer() {
      return (this.stats.length > 0) ? this.stats.reduce((x, y) => (x.pointsPlayed - y.pointsPlayed < 0) ? x : y) : "";
    },
    mostEffectivePlayer() {
      return (this.stats.length > 0) ? this.stats.reduce((x, y) => (x.pointsLost - y.pointsLost < 0) ? x : y) : "";
    }
  },
  mounted() {
    axios
      .get("/stats")
      .then(response => {
        this.stats = response.data.map(stat => {
          return {
            'id': stat.player.id,
            'firstname': stat.player.firstname,
            'name': stat.player.name,
            'matchPlayed' : stat.matchWon + stat.matchLost + stat.matchDraw,
            'matchAsReferee': stat.player.wasReferee
          }
        });
      });
  },
  methods: {
    sortPlayersBy(sortKey){
      this.stats = this.stats.sort((x, y) => y[sortKey] - x[sortKey])
    }
  }
};
</script>
<style scoped>

tbody tr:nth-child(odd) {
  background-color: #f1f1f1;
}
tbody tr:nth-child(even) {
  background-color: white;
}
tbody td{
  padding: 10px;
}
thead{
  background-color: #b7f0ff;
}
thead th{
  color: #404040;
  padding: 10px;
}
thead th a{
  color: #404040;
}
table {
  margin-bottom: 20px;
}

</style>
